/**
 * 在线客服中间件
 */
/* eslint-disable max-len */
export default function ({ app, store }) {
  // 客户端环境不执行
  if (process.client) return

  const { locale } = store.state

  if (locale === 'hk') {
    app.head.script.push({

      innerHTML: 'window.$crisp=[];window.CRISP_WEBSITE_ID="28425d7c-2914-469a-8040-e14f2b8f7bd9";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();',
      async: true,
    })
  }

  /* qiyu middleware */

  // if (locale === 'us') {
  //   app.head.script.push({
  //     innerHTML: `
  //       (function (w, d, n, a, j) {
  //         w[n] = w[n] || function () {
  //           (w[n].a = w[n].a || []).push(arguments);
  //         };
  //         j = d.createElement('script');
  //         j.async = true;
  //         j.src = 'https://servehub.aiconn.com/script/a8d0445a3ed9b92d7244efbf158dc527.js';
  //         // 安全地添加到head中
  //         var head = d.getElementsByTagName("head")[0] || d.documentElement;
  //         head.appendChild(j);
  //       })(window, document, 'ysf');

  //       // 获取用户信息
  //       const getCookie = function(name) {
  //         const value = '; ' + document.cookie;
  //         const parts = value.split('; ' + name + '=');
  //         if (parts.length === 2) return parts.pop().split(';').shift();
  //         return '';
  //       };

  //       const language = getCookie('_app_language') || 'en';
  //       const uid = getCookie('_app_uid') || '';
  //       const accountCard = getCookie('_app_card_id') || '';
  //       const schoolTag = getCookie('_app_school_tag') || 'US';

  //       // 七鱼配置映射
  //       const map = {
  //         hk: {
  //           robotId: 5328340,
  //           templateId: 6638243,
  //           language: 'zh-tw',
  //         },
  //         en: {
  //           robotId: 5329354,
  //           templateId: 6638243,
  //           language: 'en',
  //         },
  //       };

  //       const curLanguage = ['zhHK', 'zh'].includes(language) ? 'hk' : 'en';
  //       const curInfo = map[curLanguage];

  //       // 动态加载crypto-js/md5
  //       const loadCryptoJS = function() {
  //         return new Promise((resolve) => {
  //           if (window.CryptoJS && window.CryptoJS.MD5) {
  //             resolve(window.CryptoJS.MD5);
  //             return;
  //           }
  //           const script = document.createElement('script');
  //           script.src = 'https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.1.1/crypto-js.min.js';
  //           script.onload = () => resolve(window.CryptoJS.MD5);
  //           document.head.appendChild(script);
  //         });
  //       };

  //       // 等待SDK加载完成后初始化
  //       setTimeout(async function() {
  //         if (window.ysf) {
  //           try {
  //             const md5Hash = await loadCryptoJS();
  //             const config = {
  //               uid: accountCard.toString(),
  //               isShowBack: 0,
  //               robotShuntSwitch: 1,
  //               robotId: curInfo.robotId,
  //               templateId: curInfo.templateId,
  //               language: curInfo.language,
  //               tags: schoolTag.toUpperCase(),
  //               authToken: md5Hash(accountCard.toString() + 'hwlzam9zzhgfg7g').toString(),
  //             };

  //             ysf('config', {
  //               ...config,
  //               success: function() {
  //                 console.log('七鱼SDK初始化成功');
  //                 ysf('open');
  //               },
  //               error: function(error) {
  //                 console.log('七鱼SDK初始化失败:', error);
  //               }
  //             });
  //           } catch (error) {
  //             console.log('CryptoJS加载失败:', error);
  //           }
  //         } else {
  //           console.log('七鱼SDK未加载完成');
  //         }
  //       }, 1000);
  //     `,
  //     async: true,
  //   })
  // }
}
